import FooterNav from "../FooterNav";
import LogoFooter from "../LogoFooter";
import styles from "./Footer.module.css";
const Footer: React.FC = () => {
  return (
    <footer className={`${styles.footer} grid-container`} data-theme="dark">
      <aside className="sm-col-span-8 lg-col-span-6">
        <LogoFooter />
      </aside>

      <div className={`sm-col-span-8 lg-col-span-6 ${styles.navItems}`}>
        <FooterNav
          title="The company"
          links={[
            { label: "About Us", href: "/about" },
            { label: "Contact Us", href: "/contact" },
          ]}
        />
        <FooterNav
          title="Our network"
          links={[
            {
              label: "IWG Group",
              href: "https://www.iwgplc.com/",
              external: true,
            },
            { label: "Regus", href: "https://www.regus.com/", external: true },
            {
              label: "Spaces",
              href: "https://www.spacesworks.com/",
              external: true,
            },
            {
              label: "HQ",
              href: "https://www.hq.com/",
              external: true,
            },
          ]}
        />
        <FooterNav
          title="Places to work"
          links={[
            { label: "Locations", href: "/locations" },
            { label: "Cities", href: "/cities" },
          ]}
        />
        <FooterNav
          title="Ways to work"
          links={[
            { label: "Coworking", href: "/offerings/coworking" },
            { label: "Office Space", href: "/offerings/office-space" },
            { label: "Meeting Rooms", href: "/offerings/meeting-rooms" },
            { label: "Virtual Office", href: "/offerings/virtual-office" },
          ]}
        />
        <FooterNav
          title="Insights"
          links={[{ label: "Articles", href: "/discover" }]}
        />
      </div>

      <div className="sm-col-span-8 lg-col-span-12 ">
        <hr />
      </div>

      <div className={`sm-col-span-8 lg-col-span-6 muted ${styles.copyright}`}>
        <p>
          &copy; International Workplace Group plc {new Date().getFullYear()}
        </p>
      </div>

      <div className={`sm-col-span-8 lg-col-span-3  ${styles.legal}`}>
        <FooterNav
          title="Legal"
          links={[
            {
              label: "Cookie Policy",
              href: "https://www.hq.com/en/legal/privacy-policy",
              external: true,
            },
            {
              label: "Privacy Policy",
              href: "https://www.hq.com/en/legal/privacy-policy",
              external: true,
            },
            {
              label: "Terms and Conditions",
              href: "https://www.hq.com/en/legal/terms-conditions",
              external: true,
            },
          ]}
        />
      </div>

      {/* <nav className={`sm-col-span-8 lg-col-span-3 muted ${styles.social}`}>
        <ul>
          <li>
            <Link href="https://www.facebook.com/">
              <Facebook />
            </Link>
          </li>
          <li>
            <Link href="https://www.instagram.com/">
              <Instagram />
            </Link>
          </li>
          <li>
            <Link href="https://www.linkedin.com/">
              <LinkedIn />
            </Link>
          </li>
          <li>
            <Link href="https://twitter.com/">
              <X />
            </Link>
          </li>
        </ul>
      </nav> */}
    </footer>
  );
};

export default Footer;
